import * as yup from "yup";

export const studioRelationsFormSchema = yup
  .object({
    firstStudioId: yup.number().required().defined(),
    secondStudioId: yup.number().required().defined(),
  })
  .required();

export type IStudioRelationsWizardFormModel = yup.InferType<
  typeof studioRelationsFormSchema
>;

export const studioRelationsFormDefaultValues: IStudioRelationsWizardFormModel =
  {
    firstStudioId: 0,
    secondStudioId: 0,
  };
